// extracted by mini-css-extract-plugin
module.exports = {"closeAccountBorder":"AccountForm_closeAccountBorder__1gqnv"};